import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@shared/components/ui/cn';

/**
 * Rotating ring loader for area/page loading states (lists use skeletons).
 * Renders nothing for the first `delayMs` so fast loads don't flash a
 * seemingly-static donut — by the time it appears, the rotation is visible.
 */
export function Spinner({ className, delayMs = 150 }: { className?: string; delayMs?: number }) {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(delayMs <= 0);

  useEffect(() => {
    if (delayMs <= 0) return;
    const timer = setTimeout(() => {
      setVisible(true);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [delayMs]);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-label={t('ui.loading', 'Loading')}
      className={cn(
        'size-8 animate-spin rounded-full border-4 border-primary border-t-transparent',
        className,
      )}
    />
  );
}
